import React from 'react';

interface AIVerdictErrorFallbackProps {
  onRetry: () => void;
}

const AIVerdictErrorFallback: React.FC<AIVerdictErrorFallbackProps> = ({ onRetry }) => {
  return (
    <div className="text-center py-6">
      <div className="w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-3">
        <svg
          className="w-6 h-6 text-red-600 dark:text-red-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.268 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <p className="text-red-600 dark:text-red-400 text-sm mb-4">
        Failed to generate AI verdict. Please try again.
      </p>
      <button
        onClick={onRetry}
        className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md transition-colors duration-200"
      >
        Try Again
      </button>
    </div>
  );
};

export default AIVerdictErrorFallback;